module.exports = __webpack_public_path__ + "static/kehinde-86c0f5229ec1a766609c66cee1af1ec7.jpg";